import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'

import { ThemeColor } from 'utils/themes/types'

type CloseButtonProps = {
  onPress: () => void
  color: ThemeColor
}

export const CloseButton = ({ onPress, color }: CloseButtonProps) => {
  return (
    <Box
      width={36}
      height={36}
      margin={{ left: 'xs' }}
      align='flex-end'
      testID='BottomSheetModalCloseButton'
    >
      <Pressable onPress={onPress}>
        <Icon name='x' color={color} size={26} />
      </Pressable>
    </Box>
  )
}
